import ApplicationDetail from "#/modules/applications/ApplicationDetail";

export default ApplicationDetail;
